<!-- <app-survay-header></app-survay-header> -->
<div class="Main-Cont">
    <div class="Ques-Cont">
        <div class="text-dark fs-5 fw-bold">
            <!-- What is your Gender&#63; -->
            {{qService.currentQuestion.question_text}}
        </div>
        <div class="text-muted fs-6 fw-normal mt-2">
            You can choose multiple answers
        </div>
        <div class="Image-Cont">
            <ng-container *ngFor="let Ques of format_question_options;let i=index">
                <div class="label-div border border-muted">
                    <input 
                        type="checkbox" 
                        class="multi_select_input"  
                        [name]="'multi-Option'"
                        [value]="Ques.miscellaneous.label" 
                        [checked]="checkedElement(Ques.miscellaneous.label)"
                        (change)="multiOptionsSwitch(Ques.miscellaneous.label,i)"
                    />
                    <div class="vertical_div">
                        <img class="image_tag" [src]="makeSrcUrl(Ques.text)" alt="" />
                        <div class="fw-bold text-dark lable-text">
                            {{Ques.miscellaneous.label}}
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="footer">
        <div class="text-dark fw-bold fs-4  text-end">Q{{qService.currentQuestion.ques_index}}</div>
        <div class="text-end" *ngIf="page_image_show*6>qService.currentQuestion.options.length">
            <button class="btn btn-primary" (click)="next()">Next</button>
        </div>
        <div *ngIf="page_image_show*6<qService.currentQuestion.options.length" class="text-end">
            <button class="btn btn-primary" (click)="Image_next()">Next</button>
        </div>
    </div>
</div>
